export default {
  textColor: '#AAA',
  textEmphasizeColor: '#FFF',
  transparentGrey: 'rgba(20,20,20,.9)',
}
